<template>
  <div class="without-group-checkbox-root">
    <CheckboxSimple
      :markFormDirty="false"
      title="Sem Grupo/Subgrupo"
      :disabled="disabled || loadingWithoutGroup"
      v-model="withoutGroupChecked"
    />
    <div
      v-if="loadingWithoutGroup"
      class="without-group-checkbox-loading"
    >
      <vue-loading
        type="bubbles"
        color="#D98621"
        :size="{ width: '22px', height: '22px' }"
      ></vue-loading>
    </div>
  </div>
</template>

<script>
import CheckboxSimple from "@nixweb/nixloc-ui/src/component/forms/CheckboxSimple";

import { mapActions, mapMutations, mapState } from "vuex";

export default {
  name: "WithoutGroupSubgroupCheckbox",
  props: {
    rentId: {
      type: [String],
      required: true,
    },
    periodRentId: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CheckboxSimple,
  },
  data() {
    return {
      withoutGroupChecked: false,
      loadingWithoutGroup: false,
      syncingFromStore: true,
      skipNextCheckboxUpdate: false,
      urlUpdate: "/api/v1/rental/rent/update-without-group-subgroup",
    };
  },
  mounted() {
    this.withoutGroupChecked = this.withoutGroupStructure;
    this.syncingFromStore = false;
  },
  computed: {
    ...mapState("rent", ["withoutGroupStructure"]),
  },
  methods: {
    ...mapActions("generic", ["putApi"]),
    ...mapMutations("generic", ["addEvent"]),
    ...mapMutations("rent", ["setWithoutGroupStructure"]),
    async updateWithoutGroupSubgroup() {
      this.loadingWithoutGroup = true;
      const params = {
        url: this.urlUpdate,
        notNotifyToast: true,
        obj: {
          rentId: this.rentId,
          periodRentId: this.periodRentId,
          withoutGroupSubgroup: this.withoutGroupChecked,
        },
      };
      try {
        const response = await this.putApi(params);
        if (response?.success) {
          this.setWithoutGroupStructure(this.withoutGroupChecked);
          this.addEvent({
            name: "withoutGroupSubgroupUpdated",
            data: {
              enabled: this.withoutGroupChecked,
              rentId: this.rentId,
              periodRentId: this.periodRentId,
            },
          });
          return;
        }
        this.withoutGroupChecked = this.withoutGroupStructure;
      } catch (e) {
        this.withoutGroupChecked = this.withoutGroupStructure;
      } finally {
        this.loadingWithoutGroup = false;
      }
    },
  },
  watch: {
    withoutGroupChecked: {
      handler(value, oldValue) {
        if (this.skipNextCheckboxUpdate) {
          this.skipNextCheckboxUpdate = false;
          return;
        }
        if (this.syncingFromStore || value === oldValue) return;
        this.updateWithoutGroupSubgroup();
      },
    },
    withoutGroupStructure: {
      handler(value) {
        if (this.withoutGroupChecked === value) return;
        this.skipNextCheckboxUpdate = true;
        this.withoutGroupChecked = value;
      },
    },
  },
};
</script>

<style scoped>
.without-group-checkbox-root {
  display: inline-flex;
  align-items: center;
}

.without-group-checkbox-loading {
  margin-left: 8px;
  display: inline-flex;
  align-items: center;
}
</style>